import React from 'react';
import ProjectDetail from './ProjectDetail';
import { projectMeta } from './data';
import DeferredIframe from '../components/DeferredIframe';
import { toCdn } from '../utils/cdn';
import Figure from '../components/Figure';
import ProgressiveImg from '../components/ProgressiveImg';

export default function AIProxy() {
  const meta = projectMeta.aiproxy;
  return (
    <ProjectDetail title={meta.title} date={meta.date} role={meta.role} url={meta.url}>
      {/* Custom per-project content goes here */}

      <p>Like a lot of developers building with AI APIs, my cofounder and I ran into the same headache over and over—how to keep our API keys secure once we shipped to production. Every "solution" we found was either way too complex or fundamentally insecure. After digging through pages of bad advice, we decided to build something better ourselves. That project became AIProxy.</p>

      <p>AIProxy lets developers securely call APIs without needing to build or maintain their own backend. We started with a simple MVP, but quickly realized we needed a dashboard to manage API keys and usage. We talked to hundreds of developers, learned about their security pain points, launched a beta and soon thousands were using AIProxy to handle millions of API requests.</p>

      <p>As cofounder, I'm responsible for the product's design, the front-end engineering behind our website and dashboard, and the educational content and sample apps that help developers learn and adopt AIProxy. Below is a selection of visuals showing the product in action.</p>

      <div className="media-gallery">

        <Figure caption="Marketing Site">
          <ProgressiveImg
            src={toCdn('/images/projects/aiproxy/aiproxy_1.webp')}
            alt="Marketing Site"
            className="gallery-item"
          />
        </Figure>

        <Figure caption="Dashboard">
          <ProgressiveImg
            src={toCdn('/images/projects/aiproxy/aiproxy_2.webp')}
            alt="Dashboard"
            className="gallery-item"
          />
        </Figure>

        <div className="video-mask">
          <DeferredIframe
            src="https://www.youtube.com/embed/oDu9aGGUMfU?rel=0&controls=1&showinfo=0&modestbranding=0"
            alt="AIProxy Walkthrough"
            title="AIProxy Walkthrough"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="gallery-item"
            loading="lazy"
          />
        </div>

        <div className="video-mask">
          <DeferredIframe
            src="https://www.youtube.com/embed/B9WSdBuueXQ?rel=0&controls=1&showinfo=0&modestbranding=0"
            alt="Launch Video"
            title="Launch Video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="gallery-item"
            loading="lazy"
          />
        </div>
      </div>

      <h3>Sample Apps</h3>
      <p>During the course of building AIProxy, I've built and launched over 15 apps on the App Store to stress test our client library called AIProxySwift. This was a great way to ensure that AIProxy was robust and reliable and that it could handle the demands of real-world use. The apps ranged from simple photo editing tools to more complex applications like a realtime interview assistant. You can check out the full list of apps <a href="https://www.hamiltonzell.dev" target="_blank" rel="noopener noreferrer">here</a>.</p>

      <div className="media-gallery">
        <Figure caption="Sample Apps">
          <ProgressiveImg
            src={toCdn('/images/projects/aiproxy/aiproxy_4.webp')}
            alt="Sample Apps"
            className="gallery-item"
          />
        </Figure>
      </div>
    </ProjectDetail>
  );
}
